
import React from 'react';
import 'swiper/swiper.min.css';
import '../../resources/css/notice-page.css';
import i18n from '../../i18n';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import { MessengerModule } from '../../messenger/module';
import { Menu } from '../../constants/type.constant';
import _ from 'lodash';
import MenuItem from './home-menu-item.componemt';

class HomeMenuComponent extends React.Component<Props, State>{
    public messengerModule: MessengerModule;
    constructor(props: Props) {
        super(props);
        this.state = {
            isLoading: false,
        }
        this.messengerModule = new MessengerModule(this.props.enqueueSnackbar);
    }

    // *********************
    // 生命周期
    // *********************
    public UNSAFE_componentWillMount() {
    }
    public componentDidMount() { }

    // *********************
    // 方法区
    // *********************

    // *********************
    // 视图区
    // *********************

    render() {
        // const { specialMenu, normalMenu } = this.state;
        const { specialMenu, normalMenu } = this.props;
        return (
            <React.Fragment>
                <div className={'homeTitle'}>{i18n.t('auto_open_page_text_menu')}</div>
              
                <div className="selectedMenu-main">
                    {/* 普通菜菜单 */}
                    {
                        _.has(normalMenu, 'main_group_name') &&
                        <MenuItem
                            disabled={true}
                            item={normalMenu}
                            updateState={() => { }}
                        />
                    }
                    {/* 特殊菜菜单 */}
                    {
                        specialMenu.map((item, index) => {
                            return (
                                <MenuItem
                                    disabled={true}
                                    key={index}
                                    item={item}
                                    updateState={() => { }}
                                />
                            );
                        })
                    }
                </div>


            </React.Fragment>
        )
    }

}
export default withSnackbar(HomeMenuComponent);

// **********
// TYPE
// **********

type Props = {
    // 普通菜单数据
    normalMenu: Menu;
    // 备选菜单数据
    specialMenu: Array<Menu>;

} & WithSnackbarProps

type State = {
    isLoading: boolean;
}
